import axios from "@/api/axiosInstance";
import { FetchRecurringEmailSubscriptionsResponse } from "./types";

export const fetchRecurringEmailSubscriptions = async (
  employeeUuid: string,
): Promise<FetchRecurringEmailSubscriptionsResponse> => {
  const response = await axios.get<FetchRecurringEmailSubscriptionsResponse>(
    `/api/private/admin/employees/${employeeUuid}/recurring-emails`,
  );
  return response.data;
};
